<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Forgot Your Password?</h4>
        <button class="btn-close py-0" type="button" (click)="close()"></button>
    </div>
    <form class="theme-form" [formGroup]="form" (submit)="forgotPassword()" ngNativeValidate>
        <div class="modal-body">
            <p class="mt-2">Please enter the email address where you'd like to receive your password reset instructions.
            </p>
            <div class="form-group">
                <label class="col-form-label">Enter Email Address</label>
                <input class="form-control" formControlName="email" type="email" required="" placeholder="Email" />
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary me-2" type="button" (click)="close()">Back to Login</button>
            <button class="btn btn-primary" type="submit">Request Reset Link</button>
        </div>
    </form>
</div>